export function determineUser(result) {

  return result.usersMap[result.activity.startupUserId];

}